import {AppliedRangeFilterController} from 'plugins/modules/filter/components/AppliedRangeFilterController';
import {IAppliedFilter} from 'plugins/modules/filter/helpers/BrowserFilters/AppliedFilters';
import React, {useCallback, useMemo} from 'react';
import {useFiltersRouterPush} from '../useFiltersRouterPush';
import {isBrowserContext} from 'core/helpers';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {AppliedFilterSingleItem} from 'plugins/modules/filter/components/AppliedFilterSingleItem';
import {IFilterFacet, IFilterFacetVariant} from 'plugins/modules/filter/types';
import {useOptimisticAppliedFilters} from './useOptimisticAppliedFilters';
import {RANGE_TYPES} from 'plugins/modules/filter/constants';

export const useAppliedFiltersList = (appliedFilters: IAppliedFilter[]) => {
    const {pushRoute} = useFiltersRouterPush();

    const filterInstance = useMemo(() => (isBrowserContext() ? BrowserFilters.getInstance() : null), []);

    const {optimisticFilters, removeFilterOptimistically, isFilterRemoved} =
        useOptimisticAppliedFilters(appliedFilters);

    const handleDiscard = useCallback(
        (filter: IFilterFacet, variant?: IFilterFacetVariant) => {
            // оптимистично удаляем фильтр из UI
            removeFilterOptimistically(filter, variant);

            if (!filterInstance) {
                return;
            }

            let pathName;

            if (variant) {
                pathName = filterInstance.userRemoveOneFilterValue(filter, variant.code).pathName;
            } else {
                pathName = filterInstance.userRemoveFilterByCode(filter.code).pathName;
            }

            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [pushRoute, filterInstance, removeFilterOptimistically],
    );

    return useMemo(() => {
        return optimisticFilters
            .map(({filter, variant}) => {
                const {code, type} = filter;

                const isRangeFilter = RANGE_TYPES.includes(type);
                const key = `${code}-${variant?.code}`;

                // не отображаем фильтры которые были оптимистично удалены
                if (isFilterRemoved(filter, variant || undefined)) {
                    return null;
                }

                if (!isRangeFilter && variant) {
                    return (
                        <AppliedFilterSingleItem
                            key={key}
                            onClear={() => handleDiscard(filter, variant)}
                            title={`${String(variant.title)} ${filter.unit}`}
                        />
                    );
                }

                return <AppliedRangeFilterController key={key} filter={filter} onClear={() => handleDiscard(filter)} />;
            })
            .filter(Boolean);
    }, [optimisticFilters, handleDiscard, isFilterRemoved]);
};
